import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";
import { useTemplatePageContent } from "../Providers/TemplatePageContentContext";

const PageTitle = dynamic(() => import('../Reusables/PageTitle'));
const HomeDescription = ({home_page_title, isMobile}) => {

    // const { template_page_content } = useSelector((state) => state.globalReducer);
    // const page_content = template_page_content['home'];

    const {template_page_content} = useTemplatePageContent();
	const page_content = template_page_content;

    const renderTitle = () => {
        if(isMobile && home_page_title != '') return;
        if(isMobile && home_page_title == '') return page_content.section_1.title;
        if(!isMobile) return page_content.section_1.title;
    }

    return (
        <>
    
                {page_content.section_1.title != '' && <PageTitle component="h1" className="text-center uppercase default-grey">{renderTitle()}</PageTitle>}
                
                <Typography 
                    sx={{
                        paddingLeft: {xs: '1rem', lg: 0},
                        paddingRight: {xs: '1rem', lg: 0},
                        fontWeight: 400
                    }} 
                    className="f-size_2 pt-0 font-regular pl-2 pr-2 default-grey"
                >
                    {page_content.section_1.content}
                </Typography>

        </>

    )
}

export default HomeDescription